/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { firstValueFrom } from "rxjs";

import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ApiConfiguration } from "../api-configuration";
import { BaseService } from "../base-service";
import { getFortigateStats } from "../fn/stats/get-fortigate-stats";
import { GetFortigateStats$Params } from "../fn/stats/get-fortigate-stats";
import { getSubscriptionDdosTraffic } from "../fn/stats/get-subscription-ddos-traffic";
import { GetSubscriptionDdosTraffic$Params } from "../fn/stats/get-subscription-ddos-traffic";
import { getSubscriptionSls } from "../fn/stats/get-subscription-sls";
import { GetSubscriptionSls$Params } from "../fn/stats/get-subscription-sls";
import { getSubscriptionSlsYearReport } from "../fn/stats/get-subscription-sls-year-report";
import { GetSubscriptionSlsYearReport$Params } from "../fn/stats/get-subscription-sls-year-report";
import { getWirelessKpi } from "../fn/stats/get-wireless-kpi";
import { GetWirelessKpi$Params } from "../fn/stats/get-wireless-kpi";
import { DDoSStats } from "../models/d-do-s-stats";
import { FortigateStats } from "../models/fortigate-stats";
import { SlSdata } from "../models/sl-sdata";
import { WirelessStats } from "../models/wireless-stats";
import { YearReport } from "../models/year-report";
import { StrictHttpResponse } from "../strict-http-response";

@Injectable({ providedIn: "root" })
export class StatsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSubscriptionSls()` */
  static readonly GetSubscriptionSlsPath = "/dashboard/stats/sls/{subscription_id}/{year}/{month}";

  /**
   * Get Subscription Sls.
   *
   * Return Service Level Specification data for a subscription.
   *
   * Args:
   *     subscription_id: Subscription to query
   *     year: Year
   *     month: Month
   *     db: AsyncDatabase for Mongo queries
   *
   * Returns:
   *     SLSdata for that month.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionSls()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionSls$Response(
    params: GetSubscriptionSls$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<SlSdata>> {
    const obs = getSubscriptionSls(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Subscription Sls.
   *
   * Return Service Level Specification data for a subscription.
   *
   * Args:
   *     subscription_id: Subscription to query
   *     year: Year
   *     month: Month
   *     db: AsyncDatabase for Mongo queries
   *
   * Returns:
   *     SLSdata for that month.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionSls$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionSls(params: GetSubscriptionSls$Params, context?: HttpContext): Promise<SlSdata> {
    const resp = this.getSubscriptionSls$Response(params, context);
    return resp.then((r: StrictHttpResponse<SlSdata>): SlSdata => r.body);
  }

  /** Path part for operation `getSubscriptionSlsYearReport()` */
  static readonly GetSubscriptionSlsYearReportPath = "/dashboard/stats/sls/report/{subscription_id}";

  /**
   * Get Subscription Sls Year Report.
   *
   * Return the year report.
   *
   * Args:
   *     subscription_id: Subscription id
   *     db: AsyncDatabase for Mongo queries
   *
   * Returns:
   *     YearReport
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionSlsYearReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionSlsYearReport$Response(
    params: GetSubscriptionSlsYearReport$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<YearReport>> {
    const obs = getSubscriptionSlsYearReport(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Subscription Sls Year Report.
   *
   * Return the year report.
   *
   * Args:
   *     subscription_id: Subscription id
   *     db: AsyncDatabase for Mongo queries
   *
   * Returns:
   *     YearReport
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionSlsYearReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionSlsYearReport(
    params: GetSubscriptionSlsYearReport$Params,
    context?: HttpContext,
  ): Promise<YearReport> {
    const resp = this.getSubscriptionSlsYearReport$Response(params, context);
    return resp.then((r: StrictHttpResponse<YearReport>): YearReport => r.body);
  }

  /** Path part for operation `getWirelessKpi()` */
  static readonly GetWirelessKpiPath = "/dashboard/stats/wireless/{subscription_id}/{kpi_type}";

  /**
   * Get Wireless Kpi.
   *
   * Retrieve wireless kpi over time per subscription id.
   *
   * Args:
   *     subscription_id: SubscriptionId
   *     kpi_type: Kpi type
   *     frequency: frequency band
   *     params: common parameters
   *     db: AsyncDatabase for Mongo queries
   *
   * Returns:
   *     Data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWirelessKpi()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWirelessKpi$Response(
    params: GetWirelessKpi$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<WirelessStats>> {
    const obs = getWirelessKpi(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Wireless Kpi.
   *
   * Retrieve wireless kpi over time per subscription id.
   *
   * Args:
   *     subscription_id: SubscriptionId
   *     kpi_type: Kpi type
   *     frequency: frequency band
   *     params: common parameters
   *     db: AsyncDatabase for Mongo queries
   *
   * Returns:
   *     Data
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWirelessKpi$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWirelessKpi(params: GetWirelessKpi$Params, context?: HttpContext): Promise<WirelessStats> {
    const resp = this.getWirelessKpi$Response(params, context);
    return resp.then((r: StrictHttpResponse<WirelessStats>): WirelessStats => r.body);
  }

  /** Path part for operation `getFortigateStats()` */
  static readonly GetFortigateStatsPath = "/dashboard/stats/nfv/{subscriptionId}";

  /**
   * Get Fortigate Stats.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFortigateStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFortigateStats$Response(
    params: GetFortigateStats$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<FortigateStats>> {
    const obs = getFortigateStats(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Fortigate Stats.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFortigateStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFortigateStats(params: GetFortigateStats$Params, context?: HttpContext): Promise<FortigateStats> {
    const resp = this.getFortigateStats$Response(params, context);
    return resp.then((r: StrictHttpResponse<FortigateStats>): FortigateStats => r.body);
  }

  /** Path part for operation `getSubscriptionDdosTraffic()` */
  static readonly GetSubscriptionDdosTrafficPath = "/dashboard/stats/ddos/{subscription_id}";

  /**
   * Get Subscription Ddos Traffic.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionDdosTraffic()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionDdosTraffic$Response(
    params: GetSubscriptionDdosTraffic$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<Array<DDoSStats>>> {
    const obs = getSubscriptionDdosTraffic(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Subscription Ddos Traffic.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionDdosTraffic$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionDdosTraffic(
    params: GetSubscriptionDdosTraffic$Params,
    context?: HttpContext,
  ): Promise<Array<DDoSStats>> {
    const resp = this.getSubscriptionDdosTraffic$Response(params, context);
    return resp.then((r: StrictHttpResponse<Array<DDoSStats>>): Array<DDoSStats> => r.body);
  }
}
